export default {
login:{
  user:{},
  isLoading:false,
  hasError:null
},
pureActions:{
  password_reset:false
}
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js